import React, { Component } from 'react';

export default class ZSingleSelector extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phase: 0
        }

        this.openMenu = this.openMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);

        this.generateSelectionJsx = this.generateSelectionJsx.bind(this);

        this.generateOuterJsx = this.generateOuterJsx.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.phase != prevState.phase || this.props.value !== prevProps.value) {
            this.props.setGenericSelectorJsx(this.state.phase == 0 ? null : this.generateOuterJsx());
        }
    }

    openMenu() {
        this.setState({ phase: 1 });
    }

    closeMenu() {
        let self = this;
        self.setState({ phase: 2 }, () => {
            setTimeout(() => {
                self.setState({ phase: 0 });
            }, 350)
        })
    }

    generateSelectionJsx() {
        let results = [];

        if (this.state.phase === 0) {
            return results;
        } else {
            this.props.menuItems.forEach(item => {
                let displayText = this.props.displayProperty === undefined ? item : item[this.props.displayProperty];
                let submitValue = this.props.valueProperty === undefined ? item : item[this.props.valueProperty];

                results.push((
                    <div key={displayText + "-" + submitValue} className={"selection-item"} onClick={() => { this.props.onChange(submitValue) }}>
                        <div className={"selected-dot" + (this.props.value === submitValue ? " active" : "")}></div>
                        <div className={"display-text"}>{displayText}</div>
                    </div>
                ));
            });
        }

        return results;
    }

    generateOuterJsx() {
        let selectionJsx = this.generateSelectionJsx();

        return (<div className={'multi-selector-popup phase-' + this.state.phase}>
            <div className={"select-all"}>{"OPTIONS"}</div>
            <div className={"scroller"}>{selectionJsx}</div>
            <div className={"header"} onClick={this.closeMenu}>{"FINISH"}</div>
        </div>)
    }

    render() {

        let outerClass = "multi-selector-button"
        if (this.props.className != undefined) {
            outerClass += " " + this.props.className;
        }

        let buttonDisplayTextClass = "md-icon-text";
        if (this.props.value === undefined || this.props.value === null) {
            buttonDisplayTextClass += " md-text--secondary";
        }

        let buttonDisplayText = "";
        if (this.props.value === undefined || this.props.value === null || this.props.value === "") {
            buttonDisplayText = this.props.placeholder;
        } else {
            buttonDisplayText = "";
            for (var i = 0; i < this.props.menuItems.length; i++) {
                if (this.props.menuItems[i][this.props.valueProperty] === this.props.value) {
                    buttonDisplayText = this.props.menuItems[i][this.props.displayProperty];
                    break;
                }
            }
        }

        return (
            <div id={this.props.id} className={outerClass} >
                <span className={buttonDisplayTextClass} onClick={this.openMenu}>{buttonDisplayText}</span>
                <i className={"md-icon material-icons"} onClick={this.openMenu}>{"arrow_drop_down"}</i>
            </div>
        );
    }
}
